import { useState } from 'react';

import { Modal, OnSubmit, ModalType, openModal } from '@@/modals';
import { Button } from '@@/buttons';
import { SwitchField } from '@@/form-components/SwitchField';

interface Props {
  onSubmit: OnSubmit<{ deleteCluster: boolean }>;
  environmentName: string;
}

function ConfirmCancelProvisioningModal({ onSubmit, environmentName }: Props) {
  const [deleteCluster, setDeleteCluster] = useState(false);

  return (
    <Modal
      onDismiss={() => onSubmit()}
      aria-label="confirm cancel provisioning modal"
    >
      <Modal.Header title="Are you sure?" modalType={ModalType.Destructive} />

      <Modal.Body>
        <p>
          Are you sure you want to cancel the provisioning of{' '}
          <b>{environmentName}</b>? The cluster may be partially created in Omni
          and will not be usable.
        </p>
        <SwitchField
          name="deleteCluster"
          data-cy="cancel-provisioning-delete-cluster-switch"
          label="Also delete the cluster in Omni"
          checked={deleteCluster}
          onChange={setDeleteCluster}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onSubmit()}
          color="default"
          data-cy="cancel-cancel-provisioning-button"
        >
          Cancel
        </Button>
        <Button
          onClick={() => onSubmit({ deleteCluster })}
          color="danger"
          data-cy="confirm-cancel-provisioning-button"
        >
          Cancel provisioning
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export async function confirmCancelProvisioning(environmentName: string) {
  return openModal(ConfirmCancelProvisioningModal, {
    environmentName,
  });
}
